import { Button, GDSButtonProps, Modal } from "@leagueplatform/genesis-core";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";

type TrackAnalytics = {
  product_area?: string;
  screen_name?: string;
  detail?: string;
  sub_product_area?: string;
};

type Props = {
  actionType: "submit" | "cancel" | "close";
  buttonText: string;
  trackAnalytics?: TrackAnalytics;
} & Partial<GDSButtonProps<"button">>;

export const ModalActionButton = ({
  actionType,
  buttonText,
  trackAnalytics,
  onClick,
  ...buttonProps
}: Props) => {
  const defaults: Partial<GDSButtonProps<"button">> =
    actionType === "submit"
      ? { priority: "primary", size: "large" }
      : { priority: "secondary", size: "large" };

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (trackAnalytics) {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: trackAnalytics.product_area,
        sub_product_area: trackAnalytics.sub_product_area,
        screen_name: trackAnalytics.screen_name,
        detail: trackAnalytics.detail,
      });
    }
    if (onClick) onClick(event);
  };

  const button = (
    <Button {...defaults} {...buttonProps} onClick={handleClick}>
      {buttonText}
    </Button>
  );

  if (actionType === "cancel" || actionType === "close") {
    return <Modal.Close asChild>{button}</Modal.Close>;
  }
  return button;
};
